var map = {
	"./500px-white.svg": "eaf3",
	"./behance-white.svg": "2f20",
	"./deviantart-white.svg": "a4aa",
	"./discord-white.svg": "3cf9",
	"./dribbble-white.svg": "fec1",
	"./email-white.svg": "0e79",
	"./github-white.svg": "629a",
	"./instagram-white.svg": "8376",
	"./linkedin-white.svg": "34aa",
	"./medium-white.svg": "9ece",
	"./substack-white.svg": "1678"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88a1";